import { MessageAction, type OutcomingMessage } from '@/modules/main-frame/message-types'
import type { PlatformInfo } from '@/modules/platform-sdk/playgama/v1/platform'
import type { GameEvent } from '@/types'

type PlatformServiceParams = {
    currentLanguage: string
    isPaymentsSupported: boolean
    additionalPlatformInfo?: Record<string, unknown>
}

export class PlatformService {
    private readonly currentLanguage: string
    private readonly isPaymentsSupported: boolean = true
    private readonly additionalPlatformInfo?: Record<string, unknown>

    constructor(params: PlatformServiceParams) {
        this.currentLanguage = params.currentLanguage
        this.additionalPlatformInfo = params.additionalPlatformInfo
        this.isPaymentsSupported = params.isPaymentsSupported
    }

    handleMessage(event: GameEvent): OutcomingMessage {
        switch (event.data.action) {
            case MessageAction.getPlatformInfo: {
                return {
                    action: MessageAction.platformInfo,
                    originalMessageEvent: event as GameEvent,
                    payload: {
                        language: this.currentLanguage,
                        isPaymentsSupported: this.isPaymentsSupported,
                        additionalParams: {
                            clid: this.additionalPlatformInfo?.clid,
                            // Signals to the bridge that cloud-save messages are accepted for anonymous users too
                            isAnonymousCloudSaveAllowed: true,
                        },
                    } as PlatformInfo,
                }
            }

            default:
                return {
                    action: MessageAction.unknownMessageType,
                    originalMessageEvent: event as GameEvent,
                    payload: {
                        error: `Unknown message action "${event.data.action}"`,
                    },
                    type: 'error',
                }
        }
    }
}
